export default __webpack_public_path__ + "static/media/Tobias-Truebenbacher.dd8db828.jpg";